// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qmvZk","tabbyPromo":"styles_tabbyPromo__GoTCN","tabbyWomen":"styles_tabbyWomen__3tQsD","titles":"styles_titles__hBLLF"};